import { useMemo } from "react";

import useChainInfo from "@/hooks/useChainInfo";

export default function useBlockScanAddress({ address, chain, type = "tx" }: { address: string; chain: number; type?: "tx" | "address" }) {
  const { data, isLoading } = useChainInfo(chain);

  return useMemo(
    () => ({
      url: data ? `${data.explorers[0]}/${type}/${address}` : undefined,
      isLoading,
    }),
    [address, data, isLoading, type]
  );
}
